import React, { ReactNode } from 'react';

import { cn } from '@/src/util/ui';

type SidebarEntryPanelProps = {
  children?: ReactNode;
  className?: string;
};

const SidebarEntryPanel = ({ children, className }: SidebarEntryPanelProps) => {
  return (
    <div
      className={cn(
        'container--selectedEntryActions',
        'tw-text-center',
        'tw-border-l-[1px] tw-border-l-solid tw-border-l-cfo-grey-500',
        className
      )}
    >
      {children}
    </div>
  );
};

export default SidebarEntryPanel;
